<h1 mat-dialog-title>{{ title }}</h1>
<mat-dialog-content>
  <app-download [id]="downloadId"></app-download>
</mat-dialog-content>
<mat-dialog-actions class="flex-row-end">
  <button
    type="button"
    class="btn-save"
    mat-raised-button
    (click)="close(true)">
    OK
  </button>
  <button type="button" mat-raised-button (click)="close(false)">
    Cancel
  </button>
</mat-dialog-actions>
